import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { testimonials } from '@/mocks/testimonials';

export default function TestimonialSection() {
  const { t } = useTranslation('home');
  const [current, setCurrent] = useState(0);

  const prev = () => setCurrent((p) => (p === 0 ? testimonials.length - 1 : p - 1));
  const next = () => setCurrent((p) => (p === testimonials.length - 1 ? 0 : p + 1));

  const testimonial = testimonials[current];

  const testimonialImages = [
    "https://readdy.ai/api/search-image?query=Smiling%20professional%20woman%20at%20outdoor%20cafe%20terrace%20with%20laptop%2C%20warm%20golden%20hour%20sunlight%2C%20Parisian%20street%20background%20blurred%2C%20confident%20expression%2C%20casual%20chic%20attire%2C%20editorial%20lifestyle%20portrait%20photography%2C%20natural%20candid%20moment&width=800&height=1000&seq=test-woman-cafe&orientation=portrait",
    "https://readdy.ai/api/search-image?query=Thoughtful%20businessman%20leaning%20against%20bookshelf%20in%20modern%20library%2C%20soft%20natural%20light%20from%20tall%20windows%2C%20smart%20casual%20style%2C%20confident%20yet%20approachable%2C%20editorial%20portrait%20photography%2C%20warm%20wood%20interior%2C%20intellectual%20atmosphere&width=800&height=1000&seq=test-man-library&orientation=portrait",
    "https://readdy.ai/api/search-image?query=Energetic%20professional%20woman%20in%20bright%20creative%20studio%20with%20exposed%20brick%20wall%2C%20colorful%20mood%20board%20behind%2C%20genuine%20laugh%2C%20natural%20window%20light%2C%20creative%20entrepreneur%20vibe%2C%20editorial%20portrait%20photography%2C%20authentic%20joyful%20expression&width=800&height=1000&seq=test-woman-studio&orientation=portrait",
  ];

  return (
    <section className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-0 lg:gap-12 items-stretch">
          {/* Left: Image */}
          <div className="w-full lg:w-[40%] relative">
            <div className="relative w-full h-[300px] md:h-[400px] lg:h-[500px] rounded-2xl overflow-hidden">
              <img
                src={testimonialImages[current]}
                alt={testimonial.name}
                title={testimonial.name}
                className="w-full h-full object-cover object-top transition-opacity duration-500"
              />
            </div>
          </div>

          {/* Right: Content */}
          <div className="w-full lg:w-[60%] flex flex-col justify-center py-8 lg:py-12">
            <span className="text-xs tracking-widest uppercase text-foreground-400 font-medium">
              {t('testimonial_tag')}
            </span>

            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mt-2 leading-tight">
              {t('testimonial_title_line1')}<br />
              <span className="text-foreground-400">{t('testimonial_title_line2')}</span>
            </h2>

            <blockquote className="mt-8 md:mt-10 text-base md:text-lg text-foreground-700 leading-relaxed max-w-lg">
              &ldquo;{testimonial.quote}&rdquo;
            </blockquote>

            <div className="mt-6">
              <span className="text-sm md:text-base font-semibold text-foreground-900">
                &mdash; {testimonial.name}
              </span>
              <span className="text-xs md:text-sm text-foreground-500 block mt-1">{testimonial.role}</span>
            </div>

            {/* Navigation arrows */}
            <div className="flex items-center gap-3 mt-8">
              <button
                onClick={prev}
                className="w-10 h-10 md:w-11 md:h-11 rounded-full border border-foreground-300 flex items-center justify-center text-foreground-500 hover:bg-foreground-900 hover:text-background-50 hover:border-foreground-900 transition-all cursor-pointer"
                aria-label="Témoignage précédent"
              >
                <i className="ri-arrow-left-line"></i>
              </button>
              <button
                onClick={next}
                className="w-10 h-10 md:w-11 md:h-11 rounded-full bg-foreground-900 flex items-center justify-center text-background-50 hover:bg-foreground-800 transition-all cursor-pointer"
                aria-label="Témoignage suivant"
              >
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}